import axios from "axios";
import { clearStorageKeepingAttribution } from "../utils/attribution";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Partner-portal pages share this axios instance with the Talent/Client
      // app, so a 401 there must not bounce the partner to the Talent/Client
      // login — send it back to whichever sign-in page owns the current path.
      const isPartnerRoute =
        window.location.pathname.startsWith("/partner") ||
        window.location.pathname.startsWith("/portal");
      const loginPath = isPartnerRoute ? "/partner-login" : "/login";
      if (window.location.pathname !== loginPath) {
        const redirectUrl =
          window.location.pathname + window.location.search;
        clearStorageKeepingAttribution();
        // Redirect with query param
        window.location.href = `${loginPath}?redirect=${encodeURIComponent(redirectUrl)}`;
      }
    }
    return Promise.reject(error);
  }
);
